import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { getFamilies, getMerchandiseWithoutSupplier, integrateSupplierProducts } from '../../services/api';
import ConfirmModal from './confirmx';
import FeedbackModal from './FeedbackModal';

const IntegrarFornecedoresModal = ({ open, onClose, supplier }) => {
  const [families, setFamilies] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState(null);
  const [merchandises, setMerchandises] = useState([]);
  const [selectedMerchandiseIds, setSelectedMerchandiseIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Estados para confirmação e feedback
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const [submissionError, setSubmissionError] = useState('');

  // Carrega as famílias ao montar o componente
  useEffect(() => {
    const fetchFamilies = async () => {
      try {
        const response = await getFamilies();
        setFamilies(response.data);
      } catch (error) {
        console.error('Erro ao buscar famílias:', error);
      }
    };
    fetchFamilies();
  }, []);

  // Quando uma família é selecionada, busca os produtos sem fornecedor
  useEffect(() => {
    if (selectedFamily) {
      const fetchMerchandises = async () => {
        try {
          const response = await getMerchandiseWithoutSupplier(selectedFamily);
          setMerchandises(response.data);
          // Reseta a seleção ao mudar a família
          setSelectedMerchandiseIds([]);
          setSelectAll(false);
        } catch (error) {
          console.error('Erro ao buscar merchandise sem fornecedor:', error);
        }
      };
      fetchMerchandises();
    }
  }, [selectedFamily]);

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedMerchandiseIds([]);
      setSelectAll(false);
    } else {
      const allIds = merchandises.map(m => m.id);
      setSelectedMerchandiseIds(allIds);
      setSelectAll(true);
    }
  };

  // Atualiza o estado do selectAll com base na seleção atual
  useEffect(() => {
    setSelectAll(selectedMerchandiseIds.length === merchandises.length && merchandises.length > 0);
  }, [selectedMerchandiseIds, merchandises]);

  const multiSelectHeader = (
    <div className="p-multiselect-header" style={{ display: 'flex', alignItems: 'center' }}>
      <Checkbox checked={selectAll} onChange={toggleSelectAll} />
      <span style={{ marginLeft: '.5em' }}>Selecionar tudo</span>
    </div>
  );

  const itemTemplate = (option) => {
    return <div>{option.name} ({option.reference})</div>;
  };

  // Abre a modal de confirmação ao clicar em "Integrar"
  const handleIntegration = () => {
    setConfirmVisible(true);
  };

  const onConfirmIntegration = async () => {
    setConfirmVisible(false);
    setFeedbackOpen(true);
    setIsSubmitting(true);
    setSubmissionError('');
    try {
      await integrateSupplierProducts(supplier.id, { merchandise_ids: selectedMerchandiseIds });
      setSubmissionComplete(true);
    } catch (error) {
      console.error('Erro ao integrar produtos:', error);
      setSubmissionError('Erro ao integrar produtos.');
    }
    setIsSubmitting(false);
    // Fecha o modal de feedback e a modal principal após 2 segundos
    setTimeout(() => {
      setFeedbackOpen(false);
      onClose();
    }, 2000);
  };

  const onCancelIntegration = () => {
    setConfirmVisible(false);
  };

  const footer = (
    <div style={{ textAlign: 'right' }}>
      <Button label="Cancelar" onClick={onClose} className="p-button-text" />
      <Button label="Integrar" onClick={handleIntegration} disabled={selectedMerchandiseIds.length === 0} />
    </div>
  );

  return (
    <>
      <Dialog 
        header={`Integrar Produtos para ${supplier.name}`} 
        visible={open} 
        onHide={onClose} 
        style={{ width: '400px' }} 
        footer={footer} 
        modal
      >
        <div>
          <Dropdown 
            value={selectedFamily} 
            options={families} 
            onChange={(e) => setSelectedFamily(e.value)} 
            optionLabel="name" 
            optionValue="id"
            placeholder="Escolha a família de produtos" 
            style={{ width: '100%' }}
          />
          {selectedFamily && (
            <div style={{ marginTop: '1em' }}>
              <MultiSelect 
                value={selectedMerchandiseIds} 
                options={merchandises} 
                onChange={(e) => setSelectedMerchandiseIds(e.value)} 
                optionLabel="name" 
                optionValue="id" 
                placeholder="Selecione os produtos" 
                itemTemplate={itemTemplate}
                header={multiSelectHeader}
                style={{ width: '100%' }}
              />
            </div>
          )}
        </div>
      </Dialog>
      
      {/* Modal de confirmação */}
      <ConfirmModal
        visible={confirmVisible}
        message="Deseja integrar os produtos selecionados?"
        onConfirm={onConfirmIntegration}
        onCancel={onCancelIntegration}
      />
      
      {/* Modal de feedback */}
      <FeedbackModal
        open={feedbackOpen}
        isSubmitting={isSubmitting}
        submissionComplete={submissionComplete}
        error={submissionError}
        onClose={() => setFeedbackOpen(false)}
      />
    </>
  );
};

export default IntegrarFornecedoresModal;
